import { createTheme } from '@material-ui/core/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#666360',
    },
    secondary: {
      main: '#264d6b',
      // // SenecuraApp color code
      // main: '#039be5',
    },
    text: {
      main: '#fff',
    },
  },
});

export default theme;
